export default "<h5 class=\"text-center text-gray-500\">{{cardContent?cardContent:\"Coming Soon!\"}}</h5>\n"